import { inject, Injectable } from '@angular/core';
import { ICreative } from '@domain/creativeset/creative';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { CreativesetDataService } from '@studio/common';
import { map } from 'rxjs';
import * as DisplayCampaignActions from './display-campaign.actions';
import * as DisplayCampaignSelectors from './display-campaign.selectors';
import { isCreativePublishable } from './display-campaign.utils';

@Injectable({ providedIn: 'root' })
export class DisplayCampaignService {
    private store = inject(Store);
    private creativeSetDataService = inject(CreativesetDataService);

    loaded$ = this.store.select(DisplayCampaignSelectors.getLoaded);
    error$ = this.store.select(DisplayCampaignSelectors.getError);
    campaignsStatusList$ = this.store.select(DisplayCampaignSelectors.getCampaignsStatusList);
    isPublishing$ = this.store.select(DisplayCampaignSelectors.getIsPublishing);

    campaignsList$ = this.store.select(DisplayCampaignSelectors.getCampaignsList);

    hasConnectedCampaigns$ = this.store.select(DisplayCampaignSelectors.getHasConnectedCampaigns);
    hasChangesToPublish$ = this.campaignsStatusList$.pipe(
        concatLatestFrom(() => this.campaignsList$),
        map(([campaignPublishStatus, campaignsList]) =>
            this.creativeSetDataService.creativeset.creatives.some(creative =>
                isCreativePublishable(creative, campaignsList, campaignPublishStatus)
            )
        )
    );

    campaignIds$ = this.store.select(DisplayCampaignSelectors.getCampaignIds);

    pushingChangesOnCampaignIds$ = this.store.select(
        DisplayCampaignSelectors.getPushingChangesOnCampaigns
    );

    pushChangesPrompt(creatives: ICreative[]): void {
        this.store.dispatch(DisplayCampaignActions.pushChangesPrompt({ creatives }));
    }

    cancelPublish(): void {
        this.store.dispatch(DisplayCampaignActions.cancelPublish());
    }
}
